import RestService from "../services/rest.service";

export const postCreateAnnouncement = (form) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/news`, form).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const putUpdateAnnouncement = (form, serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.put(`app/admin/news/${serial}`, form).then(
      (response) => {
        let data = response
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getTagsList = (serial = '') => (dispatch) => {
  return new Promise((resolve, reject) => {
    let url = 'app/admin/news/tags'
    //if (serial) url += '/' + serial
    RestService.get(url).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAnnouncementList = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/news`).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const deleteAnnouncement = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/admin/news/${id}`).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getAnnouncementDetail = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/news/${id}`).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};